module.exports = __webpack_public_path__ + "images/emoji/new.22344fe6af00f8744249.png";